import React from 'react';
import ExternalLinkWrapper from '../navigation/ExternalLinkWrapper';

const AdditionalLinkPopoverMessage = (url, msg) => (
    <>
        <p className="popover-message">{msg}</p>
        {url && <ExternalLinkWrapper className="learn-more-link" content="LEARN MORE" path={url} />}
    </>
);

export default AdditionalLinkPopoverMessage;
